import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BehaviorService } from 'src/app/_core/_services/behavior.service';
import { ContentService } from 'src/app/_core/_services/content.service';
import { EventsService } from 'src/app/_core/_services/events.service';
import { LoginService } from 'src/app/_core/_services/login.service';
import { GlobalService } from 'src/app/_core/global.service';

@Component({
  selector: 'app-buy-voucher',
  templateUrl: './buy-voucher.component.html',
  styleUrls: ['./buy-voucher.component.scss']
})
export class BuyVoucherComponent implements OnInit, OnDestroy {

  public voucherId: string;
  public toBuyVoucher: any;
  public loading_: boolean = false;

  private UserSubscribed: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private beh: BehaviorService,
    private loginSvc: LoginService,
    private uparSvc: ContentService,
    private event: EventsService,
    public global: GlobalService
  ) {
    this.route.params.subscribe(params => { this.voucherId = params.voucherId });
    this.beh.voucherData.subscribe(v => { this.toBuyVoucher = v });
    this.beh.UserSubscription.subscribe(userSub => { this.UserSubscribed = !!userSub?.subscriptions?.length });
  }

  ngOnInit(): void {
    this.event.eventStart({ eventType: 'OFFER_PAGE_ACCESS', eventCategory: 'ACCESS' });
  }

  private _subs = new Subject();
  ngOnDestroy(): void {
    this.beh.voucherData.next(null);
    this._subs.next();
    this._subs.complete();
  }

  public doBuyVoucher() {
    this.loading_ = true;
    this.event.eventStart({ eventType: 'PURCHASE_REQUESTED', eventCategory: 'SUBMIT' });

    this.uparSvc.doVoucherRedeem({
      voucherId: this.toBuyVoucher.voucher.id,
      offerId: this.toBuyVoucher.selected.id
    }).pipe(takeUntil(this._subs)).subscribe(redeem => {
      switch (redeem?.responseCode) {
        case 'SUCCESS':
          this.loginSvc.loadUserSubscription();
          this.loginSvc.loadUserWallet();

          !redeem.isAsync && this.beh.popup.next({
            pop: 'redeem-success',
            extraData: {
              id: this.toBuyVoucher.voucher.id,
              codes: redeem.voucherCodes,
              value: this.toBuyVoucher.selected.game_coin_value,
              currency: this.toBuyVoucher.selected.game_coin_label,
              expire: redeem.expireDate
            }
          });

          redeem.isAsync && this.beh.popup.next({
            pop: 'custom',
            extraData: {
              title: 'popup.pleaseNote',
              popup_image_url: 'https://webportals.cachefly.net/global/upar/assets/images/icons/ic_pup_notifications.svg',
              dark_popup_image_url: 'https://webportals.cachefly.net/global/upar/assets/images/icons/ic_pup_notifications_dark.svg',
              subtitle: 'popup.weStillValidating',
              description: 'popup.transactionsInProgress',
              button_action_type: 'ACTION',
              button_action: '',
              button_text: 'global.continue'
            }
          });

          this.router.navigate(['wallet', 'vouchers']);
          this.event.eventStart({ eventType: 'PURCHASE_REQUESTED_SUCCESS', eventCategory: 'SUCCESS', subSource: redeem?.isAsync ? 'is-async' : 'not-async', responseData: JSON.stringify(redeem) });
          break;

        /* case '':
          this.event.eventStart({ eventType: '', eventCategory: 'SUCCESS', responseData: JSON.stringify(redeem) });
          setTimeout(() => { this.beh.popup.next({ pop: 'custom', extraData: { subtitle: 'popup.voucherPurchase', description: 'popup.voucherTakeFewMinutes', button_action_type: 'ACTION', button_action: '', button_text: 'global.continue' } }) }, 0);
          break; */

        case 'INSUFFICIENT_UPS':
          this.event.eventStart({ eventType: 'PURCHASE_REQUESTED_ERROR', eventCategory: 'ERROR', responseData: JSON.stringify(redeem) });
          this.beh.popup.next({ pop: this.UserSubscribed ? 'no-credits' : 'no-credits-subscription' });
          break;

        case 'INVALID_ACCOUNT':
          this.event.eventStart({ eventType: 'PURCHASE_REQUESTED_ERROR', eventCategory: 'ERROR', responseData: JSON.stringify(redeem) });
          this.beh.popup.next({ pop: 'access-account' });
          break;

        //-- Voucher block purchase --
        case 'SUBSCRIPTION_IS_MANDATORY':
          this.event.eventStart({ eventType: 'PURCHASE_REQUESTED_ERROR', eventCategory: 'ERROR', responseData: JSON.stringify(redeem) });

          this.beh.popup.next({
            pop: 'custom',
            extraData: {
              popup_image_url: 'https://webportals.cachefly.net/global/upar/assets/images/icons/ic_pup_6_error.svg',
              dark_popup_image_url: 'https://webportals.cachefly.net/global/upar/assets/images/icons/ic_pup_6_error_dark.svg',
              description: 'popup.needSubscription',
              button_action_type: 'ACTION',
              button_action: '',
              button_text: 'global.continue'
            }
          });
          break;

        case 'DAILY_REDEEM_CAP_ACHIEVED':
          this.event.eventStart({ eventType: 'PURCHASE_REQUESTED_ERROR', eventCategory: 'ERROR', responseData: JSON.stringify(redeem) });

          this.beh.popup.next({
            pop: 'custom',
            extraData: {
              popup_image_url: 'https://webportals.cachefly.net/global/upar/assets/images/icons/ic_pup_6_error.svg',
              dark_popup_image_url: 'https://webportals.cachefly.net/global/upar/assets/images/icons/ic_pup_6_error_dark.svg',
              description: 'popup.reachedPurchaseDailyLimit',
              button_action_type: 'ACTION',
              button_action: '',
              button_text: 'global.continue'
            }
          });
          break;

        /* case 'BLACKLISTED_ACCOUNT':
          this.event.eventStart({ eventType: 'PURCHASE_REQUESTED_ERROR', eventCategory: 'ERROR', responseData: JSON.stringify(redeem) });
          this.beh.popup.next({ pop: 'error-generic' });
          // setTimeout(() => { this.beh.popup.next({ pop: 'custom', extraData: { subtitle: 'popup.voucherPurchase', description: 'popup.voucherTakeFewMinutes', button_action_type: 'ACTION', button_action: '', button_text: 'global.continue' } }) }, 0);
          break; */

        //-- Voucher block purchase --

        default:
          this.event.eventStart({ eventType: 'PURCHASE_REQUESTED_ERROR', eventCategory: 'ERROR', responseData: JSON.stringify(redeem) });
          this.beh.popup.next({ pop: 'error-generic' });
          break;
      }
      this.loading_ = false;
    }, () => { this.loading_ = false });
  }

}